import React from 'react';

import { SettlementImportsPage } from './SettlementImportsPage';

export const settlementImportsRoutes = [
  {
    path: '',
    element: <SettlementImportsPage />,
  },
];
